import React, { Component } from "react";
import { TabberButton } from "../custom-form/tabber-button.component";
import Icons from "../../icon";
import { MAX_LENGTH, NUMBER_TYPE_FIELDNAME, TYPE_FUNCTION, DATA_TYPE } from "../../../constants/external-constants";
import { CustomSearchableSelectKeyValue } from "../custom-form/input-filter-component";
import Translation from '../../common/translation/translation.component';
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { ORFCheckbox } from "../forms/order-request-form.component";
import { connect } from "react-redux";
import { convertToFormatLocalDate } from "../../../utils/helpers.utils";
import CustomSearchableDropdownWrapper from "../custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class TableWithButton extends Component {
    constructor(props) {
        super(props);
        this.ShowUpdateBtn = this.ShowUpdateBtn.bind(this)
        this.state = {
            showUpdateBtn: false,
            deleteIndex: 0,
            editMode: false,
            dataItem: this.props.datatable,
            selectedGlCode: null,
            selectedCostCenter: null,
            percent: null,
            editModeIndex: null,
            headerCount: 0,
            showDltModal: false,
            fileChange: false,
            value: false,
            isUpdateData: false,
            selectAll: false,
            selectedItems: {},
            checkedItems: [],
            localValue: {},
            onCheckBoxTick: false,
            initialEditData: null
        }
    }

    componentDidMount() {
        this.calculateHeaderCount();
        this.setState({
            selectAll: true, // Default "Select All" to true
            selectedItems: this.initializeSelectedItems(this.props.datatable),
            checkedItems: this.props.checkedItems || [],
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.datatable !== this.props.datatable) {
            this.calculateHeaderCount();
            this.setState({ onCheckBoxTick: false })
        }
        if (prevProps.enableEdit !== this.props.enableEdit) {
            if (!this.props.enableEdit) {
                this.HideUpdateBtn();
                this.disableEditMode();
            }
        }
    }
    // Add this function to initialize selected items based on the datatable prop
    initializeSelectedItems = (datatable) => {
        const selectedItems = {};
        datatable.forEach(item => {
            item.dataItem.forEach((_, itemKey) => {
                selectedItems[itemKey] = true; // Set each item as selected by default
            });
        });
        return selectedItems;
    };
    calculateHeaderCount = () => {
        let count = 0;
        this.props.datatable.forEach(item => {
            item.HeaderItem.forEach(header => {
                const columns = Object.values(header).sort((a, b) => (a.order - b.order));
                const visibleColumns = columns.filter(row => row.hidden === false);
                count += visibleColumns.length;
            });
        });
        if (this.props.haveToggle) {
            count += 3;
        }
        this.setState({ count: count });
    }

    ShowUpdateBtn(index) {
        this.setState({
            showUpdateBtn: true,
            fileChange: false
        })
        this.enableEditMode();
    }
    HideUpdateBtn() {
        this.setState({
            showUpdateBtn: false,
            initialEditData: null,
            localValue: {}
        })
        if (typeof this.props.handelEnableEdit === TYPE_FUNCTION) {
            this.props.handelEnableEdit(false, null)
        }

        if (this.props.planComponentError) {
            this.props.setDefaultError();
        }
        this.disableEditMode();
    }

    enableEditMode = () => {
        this.setState((prevState) => ({
            editMode: true
        }));
    };

    disableEditMode = () => {
        this.setState((prevState) => ({
            editMode: false
        }));
    }

    enableUpdate() {
        if (typeof this.props.enableUpdate === TYPE_FUNCTION) {
            this.props.enableUpdate(true)
        }
        if (typeof this.props.toggleDropdown === TYPE_FUNCTION) {
            this.props.toggleDropdown()
        }
        if (typeof this.props.showDetails === TYPE_FUNCTION) {
            this.props.showDetails(false);
        }
    }

    renderTableDataValue(props, item, c) {
        const { activeDateFormat } = this.props.adminSetting;
        if (c.propName === "Date") {
            const rawValue = item[c.propName];

            if (typeof rawValue === 'string' && rawValue.includes(' - ')) {
                const [start, end] = rawValue.split(' - ');
                const formattedStart = convertToFormatLocalDate(start.trim(), activeDateFormat.Name);
                const formattedEnd = convertToFormatLocalDate(end.trim(), activeDateFormat.Name);
                return `${formattedStart} - ${formattedEnd}`;
            }
            return convertToFormatLocalDate(rawValue, activeDateFormat.Name);
        }
        return item[this.getProp(props.datatable[0].HeaderItem[0], c.name)];
    }

    getProp(columns, name) {
        return Object.entries(columns)
            .filter((x) => {
                return x[1].name === name;
            })
            .map((x) => x[0])[0];
    }

    checkBoxValue = (isChecked, index) => {
        if (typeof this.props.getCheckboxValue === TYPE_FUNCTION) {
            this.props.getCheckboxValue(isChecked, index)
            this.setState({ onCheckBoxTick: true })
        }
    }

    renderTableData = (item, itemKey) => {
        const { haveCheckBox, enableCheckBox, defaultCheckBoxValue, defaultSelected, resetCheckBox } = this.props
        const headerItem = this.props.datatable[0].HeaderItem[0];
        var checkBoxValue = this.checkCheckBoxValue(itemKey, defaultCheckBoxValue, defaultSelected);
        let listIndex = 0;

        return Object.values(headerItem).map((value, index) => {
            if (!value.hidden) {
                const result = (
                    <td
                        className="col-text-overflow"
                        key={"td-" + value.name + "-" + Object.keys(value)[0]}
                        hidden={value.hidden}
                    >
                        <div className="table-checkbox-container">
                            {(listIndex === 0 && haveCheckBox) &&
                                <ORFCheckbox
                                    checkBoxValue={(isChecked) => this.checkBoxValue(isChecked, itemKey)}
                                    initialValue={checkBoxValue}
                                    disable={!enableCheckBox}
                                    resetCheckBox={resetCheckBox}
                                    onTick={this.state.onCheckBoxTick}
                                    classWrapper="custom-checkbox-wrapper" />}
                            {this.renderTableDataValue(this.props, item, value)}
                        </div>
                    </td>
                );
                listIndex++; // Increment the visible index only if the column is not hidden
                return result;
            }
        });
    };

    checkCheckBoxValue = (itemKey, defaultCheckBoxValue, defaultSelected) => {
        if (defaultSelected == null || defaultSelected == undefined) {
            if (defaultCheckBoxValue !== undefined) {
                return defaultCheckBoxValue;
            } else {
                return true;
            }
        } else {
            if ((defaultSelected.includes(itemKey))) {
                return true;
            } else {
                if (defaultCheckBoxValue !== undefined) {
                    return defaultCheckBoxValue;
                } else {
                    return true;
                }
            }
        }
    }

    handleTableChange = (index, value, e) => {
        const newDataTable = this.props.datatable.map((item, itemIndex) => {
            if (itemIndex === index) {
                return {
                    ...item,
                    [value]: e.target.value
                };
            }
        })
        this.setState({ dataTable: newDataTable })
    }

    rowClick(index) {
        if (typeof this.props.rowClickAction === TYPE_FUNCTION) {
            this.props.rowClickAction(index);
        }
    }
    handleSelectAll = () => {
        const newSelectAllState = !this.state.selectAll;

        // Create an updated selectedItems state where all items are selected or deselected
        const updatedSelectedItems = {};
        this.props.datatable.forEach(item => {
            item.dataItem.forEach((itemData, itemKey) => {
                updatedSelectedItems[itemKey] = newSelectAllState;
            });
        });

        // Update local state
        this.setState({
            selectAll: newSelectAllState,
            selectedItems: updatedSelectedItems
        });

        // Notify the parent about the "Select All" change
        if (this.props.onSelectAllChange) {
            const allItems = this.props.datatable.flatMap(item => item.dataItem); // Flatten all data items
            this.props.onSelectAllChange(newSelectAllState, allItems); // Pass the state and all items to the parent
        }
    };

    handleCheckboxChange = (itemKey, itemData) => {
        this.setState(prevState => {
            const isChecked = !prevState.selectedItems[itemKey];
            const updatedSelectedItems = {
                ...prevState.selectedItems,
                [itemKey]: isChecked,
            };

            const allItemsSelected = Object.values(updatedSelectedItems).every(Boolean);

            if (this.props.onPlanComponentCheck) {
                const selectedDataItems = this.props.datatable
                    .flatMap(item => item.dataItem)
                    .filter((_, index) => updatedSelectedItems[index]);
                this.props.onPlanComponentCheck(isChecked, selectedDataItems);
            }

            return {
                updatedCheckboxState: updatedSelectedItems,
                selectedItems: updatedSelectedItems,
                selectAll: allItemsSelected,
            };
        });
    };


    handleInputValue(value, e) {
        const { handleInputChange } = this.props;
        const inputText = e.target.value;
        handleInputChange(value, e)

        this.setState(prevState => ({
            fileChange: true,
            localValue: {
                ...prevState.localValue,
                [value]: inputText
            }
        }));

    }

    requiredProp = (itemKey, requiredField) => {
        const fieldMap = {
            2: requiredField.IndexOne,
            3: requiredField.IndexTwo,
            4: requiredField.IndexThree,
        };

        return fieldMap[itemKey] ? 'border-red' : undefined;
    };

    callHandleGetFieldData = (index) => {
        if (this.props.datatable && this.props.datatable.length > 0) {
            const { dataItem, HeaderItem } = this.props.datatable[0];

            if (dataItem && dataItem.length > index) {
                const data = dataItem[index];
                const header = HeaderItem[0];

                for (let propName in header) {
                    let value = header[propName];

                    if (!value.hidden &&
                        (this.props.searchableDropdownData.includes(value.propName) ||
                            this.props.inputField.includes(value.propName))) {

                        const dataValue = data[value.propName];


                        if (typeof this.props.handleGetFieldData === 'function') {
                            this.props.handleGetFieldData(value.propName, data);
                        }
                    }
                }
            }
        }
    }


    //create a function here that will render a modal

    handleBtnClick = (action, index) => {
        this.props?.actionButtonValue?.(action);

        if (action === 'update') {
            const dataToEdit = this.props.datatable[0].dataItem[index];
            this.callHandleGetFieldData(index);
            this.setState({
                editModeIndex: index,
                initialEditData: dataToEdit,
                localValue: {},         
                isUpdateData: false
            }, () => {
                this.disableEditMode();
                this.handleTableUpdate(action, index);
            });

            if (typeof this.props.handelEnableEdit === 'function') {
                this.props.handelEnableEdit(true, index);
            }
            this.ShowUpdateBtn(index);

        } else if (action === 'refresh') {
            if (typeof this.props.handleRefresh === 'function') {
                this.props.handleRefresh();
            }
        } else {
            this.setState({
                showDltModal: true,
                deleteIndex: index
            });
        }
    };

    handleDeleteModal = (btnType, index) => {
        const { deleteAction, handleCloseNotif } = this.props;
        if (btnType === CONFIRMATION_VALUE.Ok) {
            if (typeof deleteAction === "function") {
                deleteAction(this.state.deleteIndex);
            }
        }
        else {
            if (typeof handleCloseNotif === "function") {
                handleCloseNotif();
            }
            this.props?.actionButtonValue?.('');
        }
        this.setState(prev => ({ showDltModal: !prev }));
    };

    handleUpdateData = (index) => {
        this.setState({ isUpdateData: true });
        const { updateAction } = this.props;
        updateAction(index)
    }

    handleTableUpdate = (btnType, index) => {
        if (typeof this.props.handelEnableEdit === TYPE_FUNCTION) {
            this.props.handelEnableEdit(true, this.state.editModeIndex)
        }
        this.ShowUpdateBtn(index)
        this.setState(prev => ({ showConfirmModal: !prev }));
    }

    handleSearchChange(value, propName, isTyping) {
        if (typeof this.props.onSearchChange === 'function') {
            this.props.onSearchChange(value, propName);
        }
    }

    handleLoading(propName) {
        var isLoading;
        if (propName === "GLCode") {
            isLoading = this.props.isLoading(propName);
        }
        else if (propName === "CostCode") {
            isLoading = this.props.isLoading(propName);
        }

        return isLoading;
    }

    handleOnLoadMore(e, propName) {

        if (propName === "GLCode") {
            this.props.onLoadMore(e, propName);
        }
        else if (propName === "CostCode") {
            this.props.onLoadMore(e, propName);
        }
    }
    renderEditTableData = (item, index) => {
        return Object.values(this.props.datatable[0].HeaderItem[0]).map((value, itemKey) => {
            if (!value.hidden) {
                if (this.props.searchableDropdownData.includes(value.propName)) {

                    const selectedValue =
                        this.props.selectedItems?.[value.propName] ??
                        this.state.initialEditData?.[value.propName + 'ID'] ??
                        item[value.propName + 'ID'];

                    let options = [];
                    if (typeof this.props.optionsMap === "function") {
                        options = this.props.optionsMap(value.propName) || [];
                    } else if (this.props.optionsMap && typeof this.props.optionsMap === "object") {
                        options = this.props.optionsMap[value.propName] || [];
                    }

                    const hasMoreFn = typeof this.props.hasMore === 'function'
                        ? this.props.hasMore
                        : () => false;

                    const finalSelectedValue = options.length > 0 ? selectedValue : null;

                    return (
                        <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                            <CustomSearchableDropdownWrapper
                                options={options ?? []}
                                selected={finalSelectedValue}
                                onChange={(e) => this.props.handleSelectChange(
                                    value.propName,
                                    e ?? { text: '', Key: null },
                                    this.state.editModeIndex
                                )}
                                maxLength={MAX_LENGTH.limit_100}
                                customClass={this.props.isExist ? 'border-red' : ''}
                                fieldProp={`${this.props.fieldProp}${value.propName}`}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                tagName='Key'
                                isDataFromTable={true}
                                propName={value.propName}
                                requiredField={true}

                                onSearchChange={(e, i) => this.handleSearchChange(e, value.propName, i)}
                                onLoadMore={(e) => this.handleOnLoadMore(e, value.propName)}
                                hasMore={hasMoreFn(value.propName)}
                                isLoading={this.handleLoading(value.propName)}
                            />
                        </td>
                    );
                } else if (this.props.inputField.includes(value.propName)) {
                    var dataValue = ""
                    if (this.state.fileChange) {
                        dataValue = this.props.selectedItems?.[value.propName]
                    } else {
                        dataValue = item[value.propName]
                    }

                    if (this.props.enableEdit && this.props.selectedItems?.[value.propName]) {
                        dataValue = this.props.selectedItems?.[value.propName]
                    }

                    if (dataValue === "" && NUMBER_TYPE_FIELDNAME.includes(value.propName)) {
                        dataValue = this.props.percentValue
                    }

                    const isType = NUMBER_TYPE_FIELDNAME.includes(value.propName) ? DATA_TYPE.number : DATA_TYPE.string;

                    return (
                        <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                            <input
                                className={`table-input__field ${this.props.planComponentError
                                    ? this.requiredProp(itemKey, this.props.hasError)
                                    : this.props.isUpdatePercent && this.state.isUpdateData && this.props.isGreater
                                        ? 'border-red'
                                        : ''
                                    }`}
                                type={isType}
                                value={
                                    this.state.localValue?.[value.propName] ??
                                    this.props.selectedItems?.[value.propName] ??
                                    this.state.initialEditData?.[value.propName] ??
                                    item[value.propName] ??
                                    ""
                                }
                                onChange={(e) => this.handleInputValue(value.propName, e)}
                                maxLength={MAX_LENGTH.inputText}
                                onInput={(e) => {
                                    if (e.target.value.length > e.target.maxLength)
                                        e.target.value = e.target.value.slice(0, e.target.maxLength)
                                }}
                            />
                        </td>
                    )
                } else {
                    var dataValue = this.props.selectedItems?.[value.propName]
                    if (dataValue) {
                        return (
                            <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                                {dataValue}
                            </td>
                        )
                    }
                    return (
                        <td key={"td-" + value.name + "-" + Object.keys(value)[0]}>
                            {
                                this.renderTableDataValue(this.props, item, value)
                            }
                        </td>
                    )
                }
            }
        });
    };

    render() {
        return (
            <div className={this.props.classNameWrapper}>
                <ConfirmationNotificationModal
                    show={this.state.showDltModal}
                    message={'Are you sure you want to delete?'}
                    title={'Delete'}
                    handleModal={(btnType) => this.handleDeleteModal(btnType, this.state.deleteIndex)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <table className={`details-view-table ${this.props.haveExternalDeleteBtn ? 'delete-table-icon' : ''}`}>
                    <thead>
                        <tr>
                            {this.props.hasColumnCheckbox && this.props.isInventoryCircuit && this.props.datatable[0]?.dataItem?.length > 0 &&
                                <th className="center-align-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={this.state.selectAll}
                                        onChange={this.handleSelectAll}
                                    />
                                </th>
                            }
                            {this.props.datatable.map((item) => {
                                return item.HeaderItem.map((header, key) => {
                                    var columns = Object.values(header).sort((a, b) => (a.order - b.order))
                                    return (
                                        columns.map((row, index) => {
                                            return row.hidden === false && <th key={index}>{row.name}</th>
                                        })
                                    )
                                })
                            })}
                            {this.props.haveToggle &&
                                <>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Execute</th>
                                </>
                            }
                            {this.props.datatable[0]?.dataItem?.length > 0 &&
                                <>
                                    {this.props.haveExternalDeleteBtn &&
                                        <th className="header-button"></th>
                                    }
                                </>
                            }

                        </tr>
                    </thead>

                    <tbody >
                        {this.props.datatable.map((item, ounterIndex) => {
                            if (item.dataItem.length > 0) {
                                return item.dataItem.map((dataItem, itemKey) => (
                                    <tr key={itemKey} onClick={this.props.haveCheckBox ? null : (this.props.haveEditBtn ? this.enableUpdate.bind(this) : () => this.rowClick(itemKey))} className="row-item">
                                        {this.props.hasColumnCheckbox && this.props.isInventoryCircuit &&
                                            <td className="center-align-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.selectedItems[itemKey] || false}
                                                    onChange={() => this.handleCheckboxChange(itemKey, item)}
                                                />
                                            </td>
                                        }
                                        {
                                            (this.state.editMode && this.state.editModeIndex === itemKey) ||
                                                ((this.state.editMode === false && this.props.enableEdit) && itemKey === this.props.keyIndex) ? (
                                                this.renderEditTableData(dataItem, itemKey)
                                            ) :
                                                this.renderTableData(dataItem, itemKey)
                                        }
                                        {this.props.haveToggle &&
                                            <>
                                                <td>
                                                    <TabberButton />
                                                </td>
                                                <td>
                                                    <TabberButton />
                                                </td>
                                                <td>
                                                    <TabberButton />
                                                </td>
                                            </>
                                        }
                                        {this.props.haveExternalDeleteBtn &&
                                            <td className={`external-action-cell ${this.props.showRefreshBtn ? 'p-0' : ""} `}>
                                                <div className="d-flex gap-2">
                                                    {this.props.showRefreshBtn &&
                                                        <div className="refresh-buttons-container">
                                                            <div className="btn-tooltiptext">
                                                                <Icons
                                                                    customClassName="icon-trash"
                                                                    name="arrow-rotate-forward"
                                                                    size="20px"
                                                                    containerClass="icon-circle-plus-container"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        this.handleBtnClick('refresh', itemKey);
                                                                    }}
                                                                />
                                                                {
                                                                    this.props.refreshTooltip &&
                                                                    <span className="tooltip-text">{this.props.refreshTooltip}</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    {!this.props.hideDeleteBtn &&
                                                        <div className="btn-tooltiptext">
                                                            <Icons
                                                                customClassName="icon-trash"
                                                                name="trash-can"
                                                                size="20px"
                                                                containerClass="icon-circle-plus-container"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.handleBtnClick('delete', itemKey);
                                                                }}
                                                            />
                                                            {
                                                                this.props.deleteTooltip &&
                                                                <span className="tooltip-text">{this.props.deleteTooltip}</span>
                                                            }

                                                        </div>
                                                    }
                                                </div>
                                            </td>
                                        }
                                        {
                                            (this.props.haveDeleteBtn || this.props.haveEditBtn) &&
                                            <td className={`edit-btn-container ${this.state.editMode ? "update-btn-container" : ""}`}>

                                                {/* ACTION BUTTONS */}

                                                {
                                                    (this.state.showUpdateBtn && this.state.editModeIndex === itemKey)
                                                        ||
                                                        ((this.state.showUpdateBtn === false && this.props.enableEdit) && itemKey === this.props.keyIndex)
                                                        ?
                                                        <div className="update-icon-container">
                                                            <Icons
                                                                customClassName="icon-xmark-reg"
                                                                name="xmark"
                                                                size="20px"
                                                                containerClass="icon-circle-plus-container"
                                                                onClick={this.HideUpdateBtn.bind(this)}
                                                            />

                                                            <Icons
                                                                customClassName="icon-check-reg"
                                                                name="check"
                                                                size="20px"
                                                                containerClass="icon-circle-plus-container"
                                                                onClick={() => this.handleUpdateData(itemKey)}
                                                            />
                                                        </div>
                                                        :
                                                        <div className="update-icon-container">
                                                            {this.props.haveDeleteBtn &&

                                                                <>
                                                                    <Icons
                                                                        customClassName="icon-trash"
                                                                        name="trash-can"
                                                                        size="20px"
                                                                        containerClass="icon-circle-plus-container"
                                                                        onClick={() => this.handleBtnClick('delete', itemKey)}
                                                                    />
                                                                </>
                                                            }

                                                            {this.props.haveEditBtn &&
                                                                <>
                                                                    <ConfirmationNotificationModal
                                                                        show={this.state.showConfirmModal}
                                                                        message={'Are you sure you want to update?'}
                                                                        title={'Update'}
                                                                        handleModal={(btnType) => this.handleTableUpdate(btnType, itemKey)}
                                                                        customClass={'comment-notification-modal modal-text-bold'}
                                                                    />
                                                                    <Icons
                                                                        customClassName="icon-pen-light"
                                                                        name="pen-light"
                                                                        size="20px"
                                                                        containerClass="icon-circle-plus-container"
                                                                        onClick={() => this.handleBtnClick('update', itemKey)}
                                                                    />
                                                                </>
                                                            }
                                                        </div>

                                                }

                                            </td>
                                        }
                                    </tr>
                                )
                                )

                            } else {
                                return (
                                    <tr key={"tr-0"} hidden={this.props.noData}>
                                        <td colSpan={this.state.count}>
                                            <h4 className="table-no-results text-align-center">
                                                <Translation translationKey="no_data_available" />
                                            </h4>
                                        </td>
                                    </tr>
                                );
                            }
                        }
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default connect(
    (state) => {
        const { adminSetting } = state;
        return { adminSetting };
    }
)(TableWithButton);